export default "__VITE_ASSET__CoEDU6rK__"